export default __webpack_public_path__ + "ubisoft-playtest-home-everyone-1.webp";